import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetRezyme = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_GROUP_REPORT_GAMES
            });

            if (data.status === 'success') {
                const rezyme = [...getState().usersMobile.rezyme.data];
                rezyme.push(data.data);
                dispatch(Action.SetGetRezymeAction({
                    data: rezyme.flat(1),
                    countPage: data.count
                }));
                dispatch(Action.SetLoadingAction(false))
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetRezyme as SetGetRezyme
}